import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { MetmindDashboardDataService } from '../metmind-dashboard-data.service';

@Component({
  selector: 'app-metmind-sidebar',
  templateUrl: './metmind-sidebar.component.html',
  styleUrls: ['./metmind-sidebar.component.scss']
})
export class MetmindSidebarComponent implements OnInit {

  queryParams: any = {};
  isInitialLoad: boolean = false;
  destroy: any = new Subject();
  sessionStorage: any = { params: {} };
  disasterTypes:any = {
    'ALL': 'All',
    'CYCLONE': 'Cyclone',
    'FLOOD': 'Flood',
    'HEAVY_RAINFALL': 'Heavy Rainfall',
    'LANDSLIDE': 'Landslide',
    'LIGHTNING': 'Lightning',
    'EARTHQUAKE': 'Earthquake',
    'DROUGHT': 'Drought',
    'HAILSTORM': 'Hailstorm',
    'HEATWAVE': 'Heatwave',
    'COLDWAVE': 'Coldwave',
    'THUNDERSTORM': 'Thunderstorm',
    'TSUNAMI': 'Tsunami',
    'AVALANCHE': 'Avalanche',
    'WILDFIRE': 'Wild Fire',
    'DAM_BREAK': 'Dam Break',
  }
  selectedType: any;

  originalOrder = (): number => 0;

  constructor(
    private gisUtils: UtilsService,
    private dataService: DataService,
    private metmindSrv: MetmindDashboardDataService,
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  subscribeEvents() {
    this.gisUtils.selectedParams
      .pipe(takeUntil(this.destroy))
      .subscribe((params: any) => {
        const sessionStorageSelectedParams: any = sessionStorage.getItem('params');
        if (Object.keys(params).length > 0) {
          this.queryParams = params;
        } else {
          this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
          this.sessionStorage.params = { ...this.queryParams };
          if (Object.keys(this.queryParams).length) {
            this.gisUtils.setSelectedParams(this.queryParams);
          }
        }
        if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
          this.selectedType = isNullOrUndefined(this.queryParams['type']) ? 'ALL' : this.queryParams['type']
        }
      });
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'METMIND';
    currentUrlParams['type'] = this.selectedType;
    let metaInfo: any = localStorage.getItem('metaInfo');
    let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
    let finalMetaInfo = metaInfoJson;
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      currentUrlParams['date'] = this.metmindSrv.formatDateToDDMMYYYY(new Date())
      const userLocationConfig = this.dataService.formQuerParamsVariables(
        finalMetaInfo.userDetailsJson.data.location,
        finalMetaInfo.userDetailsJson.data.locType
      );
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      this.isInitialLoad = false;
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

}
